/**
Project: Voice Panel (c)
Title: Table Header Columns  
Description: functions related to table header column 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { useState } from "react";
import {
  Flex,
  Button,
  Text,
  TableCell,
  Tooltip,
  ExclamationCircleIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  FilterIcon,
  Popup,
  Dropdown,
  FlexItem,
  // Checkbox,
} from "@fluentui/react-northstar";
import { VoiceAdminConstants } from "../settings/voice-admin-constants";

const TableHeaderColumn = ({
  columnId,
  columnLabel,
  isSortable,
  ischecked,
  isCheckBoxDisable,
  allCheckBoxValue,
  allCheckBoxOnChange,
  isFilter,
  filterList,
  filterApplyFunction,
  filterRemoveItem,
  filterItemValue,
  placeholderText,
  hasTooltip,
  tooltipText,
  cellClassName,
  tooltipClassName,
  sortedColumn,
  sortedOrder,
  sortFunction,
  hasButton,
  buttonFunction,
  buttonIcon,
  buttonText,
  isDisabled,
}) => {
  const [selectedItem, handleOnchange] = useState(filterItemValue || []);
  const sortList = () => {
    if (isSortable) {
      let sortOrder = VoiceAdminConstants.TABLE_DATA.SORT_ORDER.ASCENDING;
      if (columnId === sortedColumn) {
        if (
          sortedOrder === VoiceAdminConstants.TABLE_DATA.SORT_ORDER.ASCENDING
        ) {
          sortOrder = VoiceAdminConstants.TABLE_DATA.SORT_ORDER.DESCENDING;
        } else {
          sortOrder = VoiceAdminConstants.TABLE_DATA.SORT_ORDER.ASCENDING;
        }
      }
      sortFunction(columnId, sortOrder);
    }
  };

  const renderSortArrows = () => {
    if (isSortable) {
      if (columnId === sortedColumn) {
        if (
          sortedOrder === VoiceAdminConstants.TABLE_DATA.SORT_ORDER.ASCENDING
        ) {
          return <ArrowUpIcon size="small" />;
        } else {
          return <ArrowDownIcon size="small" />;
        }
      }
    }
  };

  const renderFilter = () => {
    return (
      <Flex gap="gap.small">
        <Dropdown
          value={selectedItem}
          checkable
          search
          multiple
          items={filterList}
          placeholder={placeholderText}
          onChange={(e, select) => {
            handleOnchange(select.value);
          }}
          renderItem={(Item, props) => {
            if (props.key === "") {
              return <Item {...props} header={"(Blanks)"} />;
            } else {
              return <Item {...props} header={props.header} />;
            }
          }}
          renderSelectedItem={(SelectedItem, props) => {
            if (props.key === "") {
              return <SelectedItem {...props} header={"(Blanks)"} />;
            } else {
              return <SelectedItem {...props} header={props.header} />;
            }
          }}
          getA11ySelectionMessage={{
            onRemove: (item) => {
              filterRemoveItem(item, columnId);
            },
          }}
        />
        <FlexItem>
          <Button
            onClick={(e) => filterApplyFunction(e, selectedItem, columnId)}
            text
            content="Apply"
          />
        </FlexItem>
      </Flex>
    );
  };

  return (
    <TableCell className={cellClassName}>
      <Flex
        gap="gap.smaller"
        vAlign="center"
        className="vpa-usn-table-header-cell-icon vpa-table-left"
      >
        {/* {ischecked ? (
          <Checkbox
            disabled={isCheckBoxDisable}
            checked={allCheckBoxValue}
            onChange={(e, { checked }) => allCheckBoxOnChange(checked)}
          />
        ) : null} */}
        <Text content={columnLabel} onClick={sortList} />
        {renderSortArrows()}
        {hasTooltip && tooltipText && tooltipText.length > 0 ? (
          <Tooltip
            trigger={<ExclamationCircleIcon />}
            content={<Text className={tooltipClassName}>{tooltipText}</Text>}
            align="start"
          />
        ) : null}
        {isFilter ? (
          <Popup
            position="below"
            align="center"
            pointing
            trapFocus
            trigger={
              <Button
                size="small"
                primary={filterItemValue?.length > 0 ? true : false}
                onClick={() => {
                  if (filterItemValue?.length > 0) {
                    handleOnchange(filterItemValue);
                  } else {
                    handleOnchange([]);
                  }
                }}
                text
                iconOnly
                icon={<FilterIcon />}
              />
            }
            content={renderFilter()}
          />
        ) : null}
      </Flex>
      {hasButton ? (
        <Flex gap="gap.smaller" vAlign="center">
          <Button
            size="small"
            disabled={isDisabled}
            primary
            text
            iconOnly
            icon={buttonIcon}
            content={buttonText}
            onClick={buttonFunction}
          />
        </Flex>
      ) : null}
    </TableCell>
  );
};

export default TableHeaderColumn;
